import React from "react";
import { FileText, Layout, Grid, Monitor, Smartphone, BookOpen } from "lucide-react";

interface IncludedPagesProps {
  pages: string[];
}

const IncludedPages: React.FC<IncludedPagesProps> = ({ pages }) => {
  const getIcon = (index: number) => {
    const icons = [<FileText />, <Layout />, <Monitor />, <Smartphone />, <BookOpen />];
    return icons[index % icons.length];
  };

  return (
    <div className="group/includedPages relative overflow-hidden rounded-2xl border border-navy-100 bg-gradient-to-br from-white to-gray-50 p-8 shadow-[0_8px_24px_rgba(0,31,63,0.08)]">
      {/* Encabezado flotante */}
      <div className="mb-12 flex items-start justify-between">
        <div>
          <h2 className=" text-2xl lg:text-3xl font-bold text-navy-900">
            <span className="bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">
              Included
            </span>
            <br />
            Pages & Layouts
          </h2>
          <p className="mt-2 text-navy-700">Pre-built professional templates</p>
        </div>
        <Grid className="h-12 w-12 text-navy-700" />
      </div>

      {/* Grid hexagonal dinámico */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {pages.map((page, index) => (
          <div
            key={index}
            className="relative flex items-start rounded-xl border-2 border-transparent bg-white p-6 transition-all 
                     duration-300 hover:border-blue-200 hover:shadow-[0_8px_16px_rgba(0,119,255,0.1)]"
          >
            {/* Borde animado */}
            <div className="absolute inset-0 rounded-xl border-2 border-blue-100 opacity-0 transition-opacity duration-300 group-hover/includedPages:opacity-100" />
            
            {/* Contenido de la tarjeta */}
            <div className="mr-4 flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-to-br from-blue-50 to-cyan-50">
              {React.cloneElement(getIcon(index), {
                className: "w-5 h-5 text-blue-600",
              })}
            </div>
            <div>
              <h3 className="text-lg font-semibold text-navy-900">{page}</h3>
              <p className="mt-2 text-sm text-navy-700">
                {index % 3 === 0 && "Fully responsive template"}
                {index % 3 === 1 && "Interactive components included"}
                {index % 3 === 2 && "SEO optimized structure"}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Pie decorativo */}
      <div className="mt-12 flex items-center justify-center gap-4 text-sm text-navy-700">
        <div className="h-px w-24 bg-navy-700" />
        <span>Mobile-First Approach</span>
        <div className="h-px w-24 bg-navy-100" />
      </div>
    </div>
  );
};

export default IncludedPages;